import { useEffect } from 'react';
import OInput from '../../../UI/FormControls/OInput';
import { useTranslation } from 'react-i18next';
import styles from './GeneralData.module.css';
import TextArea from '../../../UI/FormControls/TextArea';
import OAutocomplete from '../../../UI/MuiAutocomplete';
import useHttp from '../../../../hooks/use-http';
import { urls } from '../api/urls';
import AutocompleteMulti from '../../../UI/AutocompleteMulti';
import { formatDateBody } from '../../../../../utils/FormatDate';

const GeneralData = ({
  generalValue,
  setGeneralValue,
  tipId,
  idMasine,
  tipString,
}) => {
  const { t, i18n } = useTranslation();

  const { sendRequest: getVrsteKvara, data: vrstaKvaraData } = useHttp('');
  const { sendRequest: getStatusMasine, data: vrstaStatusMasine } = useHttp('');
  const { sendRequest: getMasineCombo, data: masineComboData } = useHttp('');
  const { sendRequest: getAlatiCombo, data: alatiComboData } = useHttp('');
  const { sendRequest: getProizvodCombo, data: proizvodComboData } =
    useHttp('');

  const vratiCombo = () => {
    const configMasineCombo = {
      url: urls.VRATI_MASINE,
      method: 'POST',
      data: { id: idMasine },
    };
    getMasineCombo(configMasineCombo);
    const configAlataCombo = {
      url: urls.VRATI_ALATE,
      method: 'POST',
      data: { id: idMasine },
    };
    getAlatiCombo(configAlataCombo);
    const configProizvodiCombo = {
      url: urls.VRATI_PROIZVODE,
      method: 'POST',
      data: { id: idMasine },
    };
    getProizvodCombo(configProizvodiCombo);
  };
  useEffect(() => {
    const config = {
      url: urls.GET_STATUS,
      method: 'POST',
      data: { metadata: i18n.language },
    };
    getStatusMasine(config);

    const configVrsteKvara = {
      url: urls.GET_VRSTE_KVARA,
      method: 'POST',
      data: { id: tipId, metadata: i18n.language },
    };
    getVrsteKvara(configVrsteKvara);
  }, [tipId, i18n.language]);

  useEffect(() => {
    if (masineComboData.length === 1) {
      const firstRow = masineComboData[0];
      setGeneralValue((curr) => {
        return {
          ...curr,
          nazivKlijentMasina: firstRow.vrednost,
          IdKlijentMasina: firstRow.id,
        };
      });
    }
  }, [masineComboData]);
  useEffect(() => {
    if (alatiComboData.length === 1) {
      const firstRow = alatiComboData[0];
      setGeneralValue((curr) => {
        return {
          ...curr,
          nazivKlijentAlat: firstRow.vrednost,
          IdKlijentAlat: firstRow.id,
        };
      });
    }
  }, [alatiComboData]);
  useEffect(() => {
    if (proizvodComboData.length === 1) {
      const firstRow = proizvodComboData[0];
      setGeneralValue((curr) => {
        return {
          ...curr,
          nazivKlijentProizvod: firstRow.vrednost,
          IdKlijentProizvod: firstRow.id,
        };
      });
    }
  }, [proizvodComboData]);
  useEffect(() => {
    vratiCombo();
  }, [tipId]);

  const handleChange = (e) => {
    setGeneralValue((curr) => {
      return { ...curr, [e.target.name]: e.target.value };
    });
  };

  const handleClickStatus = (e) => {
    setGeneralValue((curr) => {
      return { ...curr, statusMasine: e.vrednost, idStatusaMasine: e.id };
    });
  };
  const handleClickVrstaKvara = (e) => {
    // console.log(e);
    setGeneralValue((curr) => {
      return { ...curr, listaVrstaKvarova: e };
    });
  };
  const handleClickSelectMasina = (e) => {
    setGeneralValue((curr) => {
      return { ...curr, nazivTipaMasine: e.vrednost, IdKlijentMasina: e.id };
    });
  };
  const handleClickSelectProizvod = (e) => {
    setGeneralValue((curr) => {
      return {
        ...curr,
        nazivKlijentProizvod: e.vrednost,
        IdKlijentProizvod: e.id,
      };
    });
  };
  const handleClickSelectAlat = (e) => {
    setGeneralValue((curr) => {
      return { ...curr, nazivKlijentAlat: e.vrednost, IdKlijentAlat: e.id };
    });
  };
  // #endregion
  return (
    <div>
      <OInput
        label={`${t('title')} *`}
        name="naslov"
        value={generalValue.naslov}
        handleChange={handleChange}
        touched={generalValue.touchedNaslov}
        setTouched={() => {
          setGeneralValue((curr) => {
            return { ...curr, touchedNaslov: true };
          });
        }}
        errorMessage={`${t('title')} ${t('isRequired')}`}
        style={{ width: '100%', marginBottom: '10px' }}
      />
      <div className={styles.radiosContainer}>
        <div className={styles.radioStatus}>
          <OAutocomplete
            data={vrstaStatusMasine}
            value={generalValue.statusMasine}
            handleClick={handleClickStatus}
            label={`${
              tipString === ''
                ? ''
                : tipString === 'Robot'
                ? t('robotStatus')
                : t('moldStatus')
            }`}
            style={{ width: '100%' }}
          />
        </div>
        <div className={styles.radioStatus}>
          <AutocompleteMulti
            options={vrstaKvaraData}
            value={generalValue.listaVrstaKvarova}
            textProperty="vrednost"
            onChange={handleClickVrstaKvara}
            text={t('typeOfFailure')}
            style={{ width: '100%' }}
          />
        </div>
      </div>
      <div className={styles.radiosContainer}>
        <div className={styles.radioStatus}>
          <OAutocomplete
            data={masineComboData}
            value={generalValue.nazivKlijentMasina}
            handleClick={handleClickSelectMasina}
            label={t('machines')}
            style={{ width: '100%' }}
          />
        </div>
        {tipString === 'Robot' && (
          <div className={styles.radioStatus}>
            <OAutocomplete
              data={alatiComboData}
              value={generalValue.nazivKlijentAlat}
              handleClick={handleClickSelectAlat}
              label={t('Alat')}
              style={{ width: '100%' }}
            />
          </div>
        )}
      </div>
      <div className={styles.radiosContainer}>
        <div className={styles.radioStatus}>
          <OAutocomplete
            data={proizvodComboData}
            value={generalValue.nazivKlijentProizvod}
            handleClick={handleClickSelectProizvod}
            label={t('product')}
            style={{ width: '100%' }}
          />
        </div>
      </div>
      <div style={{ display: 'flex', gap: '5px' }}>
        <OInput
          label={`${t('errorCodeOnControlSystem')}`}
          name="kodGreske"
          value={generalValue.kodGreske}
          handleChange={handleChange}
          style={{ width: '50%' }}
        />
        <div className={styles.hoursContainer} style={{ width: '50%' }}>
          <OInput
            label={`${t('machineHours')}`}
            name="brojSatiRada"
            value={generalValue.brojSatiRada}
            handleChange={handleChange}
            style={{ width: '100%' }}
          />
          {/* <OInput
          label={`${t('spindleHours')}`}
          name="spindleHours"
          value={generalValue.spindleHours}
          handleChange={handleChange}
        /> */}
        </div>
      </div>
      <div style={{ marginBottom: '10px', marginTop: '15px' }}>
        <OInput
          label={t('rokZavrsetka')}
          style={{ width: '100%' }}
          handleChange={handleChange}
          type="date"
          value={formatDateBody(generalValue.rokZavrsetka)}
          name="rokZavrsetka"
        />
      </div>
      <TextArea
        label={`${t('problemDescription')} *`}
        rows="4"
        name="opisProblema"
        value={generalValue.opisProblema}
        handleChange={handleChange}
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default GeneralData;
